import React from 'react';
import {
  Header,
  Summary,
  Experience,
  Leadership,
  Projects,
  Skills,
  List,
  Education,
  Award,
  Interest,
  Language,
  Subject,
  Footer,
  SEO,
} from '../components';
import resume from '../../data/profile';
import '../main.css';

const Home = () => (
  <main className="antialiased text-neutral-900 bg-neutral-100 min-h-screen sm:p-5">
    <SEO title="CV" />
    <div className="container mx-auto shadow bg-white py-5 px-10">
      <Header
        contacts={resume.contact}
        name={resume.fullname}
        role={resume.role}
      />
      <Summary data={resume.summary} />
      <div className="border-b border-neutral-300 pb-2 my-5 lg:flex">
        <div className="lg:w-2/3 lg:pr-8">
          {resume.experience && <Experience data={resume.experience} />}
          {resume.leadership && <Leadership data={resume.leadership} />}
          {resume.projects && <Projects data={resume.projects} />}
        </div>
        <div className="lg:w-1/3 lg:pl-8 lg:border-l lg:border-neutral-300 ">
          {resume.skills && <Skills data={resume.skills} />}
          {resume.education && <Education data={resume.education} />}
          {resume.subject && <Subject data={resume.subject} />}
          {resume.language && <Language data={resume.language} />}
          {resume.award && <Award data={resume.award} />}
          {resume.interest && <Interest data={resume.interest} />}
          {resume.sidebar &&
            resume.sidebar.map(item => (
              <List key={`${item.title}-side`} data={item} />
            ))}
        </div>
      </div>
      <Footer social={resume.social} />
    </div>
  </main>
);

export default Home;
